



export const useSharedWithMe = (
  protocol?: { sharedWith: { userId: number, edit: boolean }[] },
  userId?: number) =>
  protocol?.sharedWith.find(u => u.userId === userId);

export const useEditable = (
  protocol?: { sharedWith: { userId: number, edit: boolean }[], userId: number, edit?: boolean },
  userId?: number) =>
{
  const owned = protocol?.userId === userId;
  return Boolean(owned || protocol?.edit || useSharedWithMe(protocol, userId)?.edit);
}